import React from 'react';
import { Form } from 'reactstrap';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton } from '../../shared';
// Formik
import { useFormik } from "formik";
import * as Yup from "yup";

export const EditIncidentCanvaModal = ({
  props,
  showModal,
  setShowModal,
  modalRespInfo,
  modalHeader,
  rowInfo
}) => {

  // Formik
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      incident: rowInfo?.incident,
    },
    validationSchema: Yup.object({
      // Add validation here if needed
    }),
    onSubmit: (values, { resetForm }) => {
      modalRespInfo(values);
      resetForm();
      setShowModal(false);
    }
  });

  const { className } = props;

  const toggle = () => {
    setShowModal(!showModal);
  };

  const onClosed = () => {
    validation.resetForm();
    setShowModal(false);
  };

  const buttons = (
    <div className="page-title-box d-flex justify-content-end">
      <BaseCustomButton
        type="submit"
        outline
        color="success"
        className="rounded-3 me-4"
        icon="mdi-content-save"
        label="Guardar"
      />
      <BaseCustomButton
        outline
        color="danger"
        className="rounded-3 me-3"
        icon="mdi-close-circle-outline"
        label="Cancelar"
        onClick={toggle}
      />
    </div>
  );

  const title = (
    <div className='d-flex ms-3 p-0'>
      <label className='m-0 p-0'>
        <h4 className='text-primary m-0 ps-4'>{modalHeader}</h4>
      </label>
    </div>
  );

  const childrenBody = (
    <>
      {title}

      <GradientDecorationLine />

      <Form
        className="form-horizontal mt-1 mb-1"
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <div className='px-5'>
          <label className='text-primary'>Comentario</label>
          <textarea
            name="incident"
            required
            className="form-control text-primary mb-4 rounded-3"
            rows="2"
            placeholder="Añadir un comentario"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.incident || ""}
          />
        </div>

        <GradientDecorationLine />

        {buttons}
      </Form>
    </>
  );

  return (
    <BaseCustomModal
      title={null}
      isModalOpen={showModal}
      handleOk={null}
      handleCancel={toggle}
      afterClose={onClosed}  
      className={className}
      footer={null} 
      width={{
        xs: '90%',
        sm: '80%',
        md: '80%',
        lg: '80%',
        xl: '80%',
        xxl: '80%',
    }}
    >
      {childrenBody}
    </BaseCustomModal>
  );
};
